<template>
  <div class="rejected-priority-poles-charts">
    <div>
      <div class="chart-total">Rejected Poles <strong>{{ rejectedPoles.poles }}</strong></div>
      <div class="chart-header">
        <div><strong>{{ rejectedPoles.reinforceable }}</strong> Reinforceable</div>
        <div>Non-Reinforceable <strong>{{ rejectedPoles.nonReinforceable }}</strong></div>
      </div>
      <RowChart
        ref="rejectedPoles"
        :data="rejectedPoles.chartData"
      />
    </div>
    <div>
      <RowChart
        ref="priorityPoles"
        :data="priorityPoles.chartData"
      />
      <div class="chart-header">
        <div><strong>{{ priorityPoles.reinforceable }}</strong> Reinforceable</div>
        <div>Non-Reinforceable <strong>{{ priorityPoles.nonReinforceable }}</strong></div>
      </div>
      <div class="chart-total">Priority Poles <strong>{{ priorityPoles.poles }}</strong></div>
    </div>
  </div>
</template>

<script>
import RowChart from "../../shared/stats/row_chart";

import Helpers from "../../../helpers.js";

export default {
  components: {
    RowChart
  },

  props: {
    rejectedAndPriorityPoles: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      rejectedPoles: {
        poles: 0,
        reinforceable: 0, 
        nonReinforceable: 0,
        chartData: []
      },

      priorityPoles: {
        poles: 0,
        reinforceable: 0, 
        nonReinforceable: 0,
        chartData: []
      }
    };
  },

  setup () {
    return {
      h$: Helpers
    }
  },

  watch: {
    rejectedAndPriorityPoles: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!newVal || newVal.length == 0) return;

        this.setChartsData(newVal);
      }
    }
  },

  computed: {
    
  },

  methods: {
    setChartsData(data) {
      // Reset the data
      this.rejectedPoles = {
        poles: 0,
        reinforceable: 0, 
        nonReinforceable: 0,
        chartData: []
      },

      this.priorityPoles = {
        poles: 0,
        reinforceable: 0, 
        nonReinforceable: 0,
        chartData: []
      },

      data.forEach(({ group, values }) => {
        const { rejected_pole, priority_pole } = group;

        const valueEntries = Object.entries(values);

        // Sum all values for total poles (excluding empty keys if needed)
        const total = valueEntries.reduce((sum, [, v]) => sum + v, 0);

        // Reinforceable = anything except "No", "", and null
        const reinforceable = valueEntries
          .filter(([k]) => k && k !== "No")
          .reduce((sum, [, v]) => sum + v, 0);

        // Non-reinforceable = key === "No"
        const nonReinforceable = values["No"] || 0;

        // Rejected Poles: rejected_pole === "Y" && priority_pole === "No"
        if (rejected_pole === "Y" && priority_pole === "No") {
          this.rejectedPoles.poles += total;
          this.rejectedPoles.reinforceable += reinforceable;
          this.rejectedPoles.nonReinforceable += nonReinforceable;
        }

        // priority Poles: priority_pole === "Yes"
        if (priority_pole === "Yes") {
          this.priorityPoles.poles += total;
          this.priorityPoles.reinforceable += reinforceable;
          this.priorityPoles.nonReinforceable += nonReinforceable;
        }
      });

      this.rejectedPoles.chartData = [
        [this.rejectedPoles.reinforceable, Math.floor((this.rejectedPoles.reinforceable / this.rejectedPoles.poles) * 100), 'Reinforceable <strong>' + this.rejectedPoles.reinforceable + '</strong>', this.h$.damageColors[3]],
        [this.rejectedPoles.nonReinforceable, Math.floor((this.rejectedPoles.nonReinforceable / this.rejectedPoles.poles) * 100), 'Non-Reinforceable <strong>' + this.rejectedPoles.nonReinforceable + '</strong>', this.h$.damageColors[0]]
      ]

      this.priorityPoles.chartData = [
        [this.priorityPoles.reinforceable, Math.floor((this.priorityPoles.reinforceable / this.priorityPoles.poles) * 100), 'Reinforceable <strong>' + this.priorityPoles.reinforceable + '</strong>', this.h$.damageColors[2]],
        [this.priorityPoles.nonReinforceable, Math.floor((this.priorityPoles.nonReinforceable / this.priorityPoles.poles) * 100), 'Non-Reinforceable <strong>' + this.priorityPoles.nonReinforceable + '</strong>', this.h$.damageColors[0]]
      ]
    }
  }
};
</script>